import React, { useCallback, useState } from "react";
import { FocusScope } from "@radix-ui/react-focus-scope";

// Dock chat devant une boîte modale (vidéo en plein écran, publication, photo…) — lot 547.
// Une modale Radix met `body { pointer-events: none }`, piège le focus et bloque la molette hors
// de la boîte : le dock restait visible mais inerte (ni fermer, ni écrire). Ici : le dock garde ses
// clics (pointer-events: auto), reprend la main sur le focus (un FocusScope remonté à chaque
// interaction met celui de la modale en pause) et fait défiler ses listes à la molette lui-même.
const prevent = (e) => e.preventDefault();
export const modalLayerOpen = () => typeof document !== "undefined" && document.body.style.pointerEvents === "none";
export const dockLayerStyle = { pointerEvents: "auto" };

const scrollableFrom = (start, stop) => {
  let el = start;
  while (el && el !== stop) {
    if (el.scrollHeight > el.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(el).overflowY)) return el;
    el = el.parentElement;
  }
  return null;
};

export const useDockOverModal = () => {
  const [epoch, setEpoch] = useState(0);
  const claim = useCallback(() => { if (modalLayerOpen()) setEpoch((n) => n + 1); }, []);
  const onWheel = useCallback((e) => {
    if (!modalLayerOpen()) return;
    const el = scrollableFrom(e.target, e.currentTarget.parentElement);
    if (el) el.scrollTop += e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
  }, []);
  const sentinel = (
    <FocusScope key={epoch} asChild trapped={false} loop={false} onMountAutoFocus={prevent} onUnmountAutoFocus={prevent}>
      <span hidden data-testid="chat-dock-focus-sentinel" />
    </FocusScope>
  );
  return { layerProps: { "data-chat-dock": "", onPointerDownCapture: claim, onFocusCapture: claim, onWheel }, sentinel };
};
